/* ===========================================================
   LureGuessr theme — global behaviors
   Ported from the prototype's inline scripts, made multi-instance
   safe and driven by data-attributes instead of hardcoded IDs.
   =========================================================== */
(function () {
  'use strict';

  /* ── Carousel(s) ── */
  document.querySelectorAll('[data-carousel]').forEach(function (track) {
    var slides = track.querySelectorAll('.carousel-slide');
    if (slides.length < 2) return;
    var wrap = track.closest('.bs-panel') || track.parentElement;
    var dots = wrap.querySelectorAll('[data-carousel-dot]');
    var current = 0;
    var timer;

    function go(n) {
      slides[current].classList.remove('active');
      if (dots[current]) dots[current].classList.remove('active');
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('active');
      if (dots[current]) dots[current].classList.add('active');
    }
    function move(dir) { go(current + dir); }
    function restart() { clearInterval(timer); timer = setInterval(function () { move(1); }, 5000); }

    var prev = wrap.querySelector('[data-carousel-prev]');
    var next = wrap.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { move(-1); restart(); });
    if (next) next.addEventListener('click', function () { move(1); restart(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { go(parseInt(dot.getAttribute('data-carousel-dot'), 10)); restart(); });
    });
    restart();
  });

  /* ── Grid density toggle(s) ── */
  document.querySelectorAll('[data-grid-toggle]').forEach(function (toggle) {
    var targetId = toggle.getAttribute('data-grid-target');
    var grid = document.getElementById(targetId) || document.querySelector('[data-product-grid]');
    if (!grid) return;
    toggle.querySelectorAll('[data-grid-cols]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cols = btn.getAttribute('data-grid-cols');
        grid.className = grid.className.replace(/grid-cols-\d+|md:grid-cols-\d+|lg:grid-cols-\d+/g, '').trim();
        grid.classList.add('grid', 'grid-cols-' + cols);
        toggle.querySelectorAll('[data-grid-cols]').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
      });
    });
  });

  /* ── Mobile filter sidebar toggle (always open on desktop via CSS) ── */
  document.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
    var content = btn.parentElement.querySelector('[data-filter-content]');
    if (!content) return;
    btn.addEventListener('click', function () {
      if (window.matchMedia('(min-width: 1024px)').matches) return;
      var open = content.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ── Filter pills (visual active state) ── */
  document.querySelectorAll('[data-filter-pills]').forEach(function (group) {
    group.querySelectorAll('.filter-pill').forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        if (pill.tagName === 'A') return; // real links navigate
        e.preventDefault();
        group.querySelectorAll('.filter-pill').forEach(function (p) { p.classList.remove('active'); });
        pill.classList.add('active');
      });
    });
  });

  /* ── Product image gallery ── */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var url = thumb.getAttribute('data-full') || thumb.src;
        if (main) {
          main.style.opacity = '0';
          setTimeout(function () { main.src = url; main.style.opacity = '1'; }, 180);
        }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  });

  /* ── Tabs ── */
  document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
    tabs.querySelectorAll('[data-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-tab');
        tabs.querySelectorAll('.tab-panel').forEach(function (p) { p.classList.remove('active'); });
        tabs.querySelectorAll('[data-tab]').forEach(function (b) { b.classList.remove('active'); });
        var panel = tabs.querySelector('[data-tab-panel="' + id + '"]');
        if (panel) panel.classList.add('active');
        btn.classList.add('active');
      });
    });
  });

  /* ── Description clamp ── */
  document.querySelectorAll('[data-desc]').forEach(function (desc) {
    var body = desc.querySelector('[data-desc-body]');
    var btn = desc.querySelector('[data-desc-toggle]');
    var label = desc.querySelector('[data-desc-toggle-label]');
    if (!body || !btn) return;

    // Only offer the toggle when text is actually being cut off. Re-measured
    // on load because a late webfont swap can change the wrapped height.
    function measure() {
      if (desc.classList.contains('is-expanded')) return;
      var clipped = body.scrollHeight - body.clientHeight > 8;
      desc.classList.toggle('is-clampable', clipped);
      btn.hidden = !clipped;
    }

    measure();
    window.addEventListener('load', measure);

    btn.addEventListener('click', function () {
      var open = desc.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (label) label.textContent = open ? 'Show less' : 'Read more';
    });
  });

  /* ── Mobile nav drawer ── */
  document.querySelectorAll('[data-mobile-toggle]').forEach(function (btn) {
    var menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;
    var iconOpen = btn.querySelector('[data-mobile-icon-open]');
    var iconClose = btn.querySelector('[data-mobile-icon-close]');

    function setOpen(open) {
      menu.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (iconOpen) iconOpen.hidden = open;
      if (iconClose) iconClose.hidden = !open;
    }

    btn.addEventListener('click', function () { setOpen(menu.hidden); });
    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { setOpen(false); });
    });
    window.addEventListener('resize', function () {
      if (window.matchMedia('(min-width: 768px)').matches) setOpen(false);
    });
  });

  /* ── Quantity steppers ── */
  document.querySelectorAll('[data-qty]').forEach(function (group) {
    var input = group.querySelector('input');
    group.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-qty-step'), 10);
        var v = Math.max(1, Math.min(99, (parseInt(input.value, 10) || 1) + delta));
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
})();
